module.exports = __webpack_public_path__ + "img/logoDomotec.c3e9c06b.png";